<template>
	<div class="floating-box">
		<header>
			<h1>{{ params.title }}</h1>
			<button @click="onClose">x</button>
		</header>
		<main>
			<p>{{ params.text }}</p>
		</main>
	</div>
</template>

<script>
export default {
	props: [
		'params'
	],
	methods: {
		onClose () {
			this.$emit('close', this.params)
		}
	},
	mounted () {
		this.$el.classList.add('show', 'fadein')
		this.$el.addEventListener('animationend', () => {
			this.$el.classList.remove('fadein')
			this.$el.classList.add('fadeout')
			this.$el.addEventListener('animationend', () => {
				this.onClose()	
			})
		})

		// timer is on css
		/*setTimeout(() => {
			this.onClose()
		}, 5000)*/
	}
}
</script>



// WEBPACK FOOTER //
// src/components/boxes/FloatingBox.vue